import React, { Component } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper/Paper';
import { withRouter } from 'react-router-dom';
import TableFooter from '@material-ui/core/TableFooter/TableFooter';
import TablePagination from '@material-ui/core/TablePagination/TablePagination';
import PropTypes from 'prop-types';
import Skeleton from 'react-loading-skeleton';

class Styledtable extends Component {
  constructor() {
    super();
    this.state = { page: 0 };
  }

  componentDidUpdate() {
    const { rowsPerPage, children: rows } = this.props;
    const { page = 0 } = this.state;
    const length = rows ? rows.length : 0;

    if (page > length / rowsPerPage && page !== 0) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ page: 0 });
    }
  }

  render() {
    const {
      classes, header, rowsPerPage, children: rows, totalRows, fetchRows,
    } = this.props;

    const { page = 0 } = this.state;
    const length = (totalRows !== -1 && totalRows) || (rows ? rows.length : 0);

    const emptyRows = rowsPerPage - Math.min(rowsPerPage, length - page * rowsPerPage);

    const rowsToShow = rows && rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    return (
      <Paper className={classes.root}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              {header.map(title => (
                <TableCell className={classes.tablecell} key={title}>{title}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rowsPerPage === -1 && rows}
            {rowsToShow}
            {(!rows || (rowsToShow.length === 0 && rows.length !== 0)) && (
              Object.keys(
                Array(emptyRows < rowsPerPage ? rowsPerPage - emptyRows : rowsPerPage).fill(0),
              )
                .map(val => (
                  <TableRow key={`skel-${val}`}>
                    {Object.keys(header).map(cval => (
                      <TableCell className={classes.tablecell} key={`skel-cell-${cval}`}><Skeleton /></TableCell>
                    ))}
                  </TableRow>
                ))
            )}
            {rowsPerPage !== -1 && length > rowsPerPage && emptyRows > 0 && (
              Object.keys(Array(emptyRows).fill(0)).map(val => (
                <TableRow key={`empty-row-${val}`}>
                  <TableCell colSpan={6} />
                </TableRow>
              ))
            )}
          </TableBody>
          <TableFooter className={classes.tableFooter}>
            <TableRow>
              <TablePagination
                count={length}
                rowsPerPage={rowsPerPage}
                rowsPerPageOptions={[]}
                page={page}
                onChangePage={(_, selectedPage) => {
                  if (rows && totalRows > -1 && selectedPage * rowsPerPage >= rows.length) {
                    fetchRows(selectedPage);
                  }
                  this.setState({ page: selectedPage });
                }}
                onChangeRowsPerPage={this.handleChangeRowsPerPage}
                labelDisplayedRows={({ from, to, count }) => `${from}-${to} av ${count}`}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </Paper>
    );
  }
}

Styledtable.propTypes = {
  classes: PropTypes.object.isRequired,
  rowsPerPage: PropTypes.number,
  header: PropTypes.array.isRequired,
  children: PropTypes.any,
  totalRows: PropTypes.number,
  fetchRows: PropTypes.func,
};

Styledtable.defaultProps = {
  rowsPerPage: 10,
  children: false,
  totalRows: -1,
  fetchRows: undefined,
};

const styles = theme => ({
  root: {
    width: '100%',
    overflowX: 'auto',
    boxShadow: 'none',
    padding: 0,
    backgroundColor: 'transparent',
  },
  tableFooter: {
    width: '100%',
  },
  table: {
    minWidth: '30rem',
  },
  tablecell: {
    fontSize: '1.1rem !important',
    color: `${theme.palette.primary.dark} !important`,
    padding: '0.5rem !important',
  },
});

export default withRouter(withStyles(styles)(Styledtable));
